import React from 'react';
import Button from '../Button/Button';

function EmptyState({
  action,
  actionLabel,
  children,
  className = '',
  icon,
  onAction,
  title,
}) {
  return (
    <div className={['custom-empty-state', className].filter(Boolean).join(' ')}>
      {icon && <span className="custom-empty-state__icon" aria-hidden="true">{icon}</span>}
      {title && <strong>{title}</strong>}
      {children && <span>{children}</span>}
      {action || (actionLabel && onAction) ? (
        action || <Button variant="secondary" size="small" onClick={onAction}>{actionLabel}</Button>
      ) : null}
    </div>
  );
}

export default EmptyState;
